import ruLocale from 'date-fns/locale/ru';
import parseDate from 'date-fns/parse';
import formatDate from 'date-fns/format';


export function parseApiDateTime(datetimestring, forceTimezone=true, timeZoneOffset='+03:00') {
  /*
   Since MyBook API does not return timezone, add it manually, if datetime string has time part.
   Avoid using timezone-database on client for bundle size reduction.
   Use lightweight timezone name as soon it is supported in date-fns,
   see https://github.com/date-fns/date-fns/issues/180
    */
  if (/^\d{4}-\d{2}-\d{2}$/.test(datetimestring)) {
    forceTimezone = false;
  };
  return parseDate(datetimestring + (forceTimezone ? timeZoneOffset: ''));
}

export function formatDateTime(datetimestring, format) {
  return formatDate(parseApiDateTime(datetimestring), format, { locale: ruLocale });
}
